import React from 'react';
import { MoreHoriz, GetApp, MenuBook, Lock } from '@mui/icons-material';
import { Button } from '@mui/material';

import { configs } from '$configs';
import { SORT, COLORS } from '$gbusiness/enums';
import CellModel from '$gbusiness/models/cell';
import { defaultDataSource, defaultStyles, TableModel } from '$gbusiness/models/table';
import { deriveRawToFile } from '$fbusiness/models/file';
import { toFileSize } from '$gbusiness/helpers/util';
import { FILE_TYPES } from '$fbusiness/enums/options/fileType';
import PATH from '$business/enums/paths';
import { Link } from '$gcomponents/primitives';

export const FILE_TABLE_CONFIG: TableModel = {
  dataSource: {
    ...defaultDataSource,
    endpoint: configs.api.file.general,
    method: 'GET',
    deriveToModel: deriveRawToFile,
    defaultSortKey: 'createdAt',
    defaultSortOrder: SORT.DSC,
    shouldVirtualize: false,
    pageSize: 20,
  },
  styles: {
    ...defaultStyles,
    color: COLORS.LIGHT,
    fontSize: '1em',
    minWidth: 600,
    maxWidth: 900,
    cellPadding: ` 8px 4px`,
    isStripped: true,
    responsive: true,
  },
  filter: {
    color: COLORS.PRIMARY,
  },
};

const FILE_TABLE = (category = FILE_TYPES.FILE): Array<CellModel> => [
  {
    label: 'SCREEN.FILES.COLS.ID',
    value: 'id',
    className: 'desktop',
    align: 'center',
    alwaysShow: true,
    width: 80,
  },
  ...(category === FILE_TYPES.FILE
    ? [
        {
          label: 'SCREEN.FILES.COLS.NAME',
          value: 'name',
          className: 'metadata',
          component: (row) => (
            <div>
              <div className="title">{row.name}</div>
              <div className="memo">{row.description}</div>
            </div>
          ),
          alwaysShow: true,
          width: 250,
        },
      ]
    : [
        {
          label: 'SCREEN.FILES.COLS.' + category + '_ID',
          value: 'name',
          className: 'metadata',
          align: 'center',
          component: (row) => {
            let path = '';
            switch (category) {
              case FILE_TYPES.ITEM:
                path = PATH.ITEMS + '/' + row.moduleId;
                break;
              case FILE_TYPES.MESSAGE:
                path = PATH.MESSAGES_ID + '/' + row.moduleId;
                break;
              case FILE_TYPES.FACTORY:
                path = PATH.SETTINGS;
                break;
              default:
                break;
            }
            if (path) return <Link route={path}>{row.moduleId}</Link>;
            return <>{row.moduleId}</>;
          },
          alwaysShow: true,
          width: 80,
        },
      ]),
  {
    label: 'SCREEN.FILES.COLS.FILE_NAME',
    value: 'fileName',
    component: (row) =>
      row.fileName ? <>{row.fileName}</> : <Link href={row.youtubeLink}>{row.youtubeLink}</Link>,
    className: 'word-break',
    alwaysShow: true,
    width: 260,
  },
  {
    label: '',
    value: 'img',
    component: (row) => (row.isImage ? <img alt="" src={row.sizes.small} width="60px" /> : ''),
    alwaysShow: true,
    width: 80,
  },
  {
    label: 'SCREEN.FILES.COLS.FILE_TYPE',
    value: 'fileType',
    sortable: SORT.ASC,
    alwaysShow: true,
    width: 100,
  },
  {
    label: 'SCREEN.FILES.COLS.MANUAL',
    value: 'isManual',
    className: 'action',
    align: 'center',
    component: (row) => (row.isManual ? <MenuBook color="primary" fontSize="small" /> : null),
    alwaysShow: true,
    width: 80,
  },
  {
    label: 'SCREEN.FILES.COLS.PROTECTED',
    value: 'isProtected',
    className: 'action',
    align: 'center',
    component: (row) => (row.isProtected ? <Lock color="action" fontSize="small" /> : null),
    alwaysShow: true,
    width: 80,
  },
  {
    label: 'SCREEN.FILES.COLS.FILE_SIZE',
    value: 'fileSize',
    className: 'action',
    sortable: SORT.ASC,
    component: (row) => <>{toFileSize(row.fileSize)}</>,
    alwaysShow: true,
    width: 120,
  },
  {
    label: '',
    value: 'download',
    className: 'action',
    component: (row) => (
      <a href={row.fileName ? row.fileUrl : row.youtubeLink} download>
        <GetApp color="secondary" />
      </a>
    ),
    alwaysShow: true,
    width: 80,
  },
  {
    label: 'SCREEN.FILES.COLS.ACTION',
    value: '',
    className: 'action',
    align: 'center',
    component: (row, actions) => {
      return (
        <Button className="left" fullWidth onClick={(e) => actions.handlePopoverOpen(e, row)}>
          <MoreHoriz />
        </Button>
      );
    },
    width: 80,
  },
];

export default FILE_TABLE;
